import { Injectable } from "@angular/core";
import { ContractEs } from "@edp-models/ES/es-contract.model";
import { EsAdditionalProduct } from "@edp-models/ES/es-product.model";
import { EdpUser } from "@edp-models/user.model";
import { ProductEsService } from "@edp-services/ES/product-es.service";
import { getContractEs } from "@edp-store/selectors/ES/contract-es.selectors";
import { getAdditionalProductEs } from "@edp-store/selectors/ES/product-es.selectors";
import { getUser } from "@edp-store/selectors/user.selectors";
import { IAppEsState } from "@edp-store/state/ES/app-es.state";
import { IAppState } from "@edp-store/state/app.state";
import { Store, select } from "@ngrx/store";

@Injectable({
    providedIn: "root",
})
export class BannerConditionESService {
    private user: EdpUser;
    public contractId: string;
    public additionalProduct: EsAdditionalProduct;

    constructor(private readonly store: Store<IAppState>, private storeEs: Store<IAppEsState>, private productService: ProductEsService) {
        this.store.pipe(select(getUser)).subscribe(user => {
            if (user) {
                this.user = user;
            }
        });

        this.storeEs.select(getAdditionalProductEs).subscribe((additionalProduct: EsAdditionalProduct) => {
            if (!!additionalProduct) {
                this.additionalProduct = additionalProduct;
            }
        });
    }

    public validate(conditions: string[]): boolean {
        if (!conditions.length) {
            return true;
        }

        return conditions.every(condition => {
            switch (condition) {
                case "BAU":
                    return this.user.profiles.includes("b2c_solar_es");
                case "CAIXA":
                    return this.user.profiles.includes("b2c_solar_caixa_es");
                case "BATERIA_SI":
                    return this.additionalProduct?.hasBattery;
                case "BATERIA_NO":
                    return !this.additionalProduct?.hasBattery;
                case "MANTENIMIENTO_SI":
                    return this.additionalProduct?.hasMaintenance;
                case "MANTENIMIENTO_NO":
                    return !this.additionalProduct?.hasMaintenance;
            }
        });
    }
}
